<div
  data-hs-carousel
  aria-label="Sentinel product screenshots"
  aria-roledescription="carousel"
  class="relative w-full"
>
  <div class="hs-carousel relative aspect-[600/343] w-full overflow-hidden bg-[#031828] shadow-sm">
    <div
      class="hs-carousel-body absolute inset-0 flex flex-nowrap transition-transform duration-700"
    >
      @for (image of images(); track image.src; let first = $first) {
        <div class="hs-carousel-slide">
          <div class="relative size-full overflow-hidden bg-[#06263a]">
            <img
              [ngSrc]="image.src"
              [alt]="image.alt"
              [priority]="first"
              fill
              sizes="(min-width: 1024px) 40vw, 92vw"
              class="object-cover object-center"
            />

            <div
              aria-hidden="true"
              class="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(52,211,153,0.12),transparent_35%),linear-gradient(180deg,rgba(3,24,40,0)_0%,rgba(3,24,40,0.28)_100%)]"
            ></div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="hs-carousel-pagination mt-5 flex justify-center gap-2.5">
    @for (image of images(); track image.src) {
      <button
        type="button"
        class="hs-carousel-pagination-item size-3 rounded-full bg-white/10 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/60 hs-carousel-active:bg-emerald-400"
        [attr.aria-label]="'Go to slide ' + ($index + 1)"
      ></button>
    }
  </div>
</div>
